const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.webp",
      txt: "유품정리",
    },
    {
      img: "/images/service2.webp",
      txt: "생전정리",
    },
    {
      img: "/images/service3.webp",
      txt: "쓰레기집청소",
    },
    {
      img: "/images/service4.webp",
      txt: "고독사청소",
    },
    {
      img: "/images/service5.webp",
      txt: "빈집정리",
    },
    {
      img: "/images/service6.webp",
      txt: "창고정리",
    },
    {
      img: "/images/service7.webp",
      txt: "폐기물처리",
    },
    {
      img: "/images/service8.webp",
      txt: "특수청소",
    },
    {
      img: "/images/service9.webp",
      txt: "사무실 정리",
    },
    {
      img: "/images/service10.webp",
      txt: "이민정리",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <div className="relative w-full h-fit flex justify-center items-end flex-nowrap sm:flex-wrap gap-3">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-auto lg:w-full h-full max-h-9 lg:max-h-11 xl:max-h-14 lg:pb-1 object-contain"
              alt="비우고 채우고 로고"
              src="/images/logo.webp"
              loading="lazy"
              width={433}
              height={82}
            />
          </div>
          <h2 className="-mb-1.5 md:-mb-1">서비스 목록</h2>
        </div>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full lg:mb-8"
          >
            <div className="relative w-full h-fit p-3 border rounded-3xl shadow-2xl hover:-translate-y-4 transition-transform duration-200">
              <div className=" relative w-full h-fit my-2 text-center">
                <p className="text-lg xl:text-2xl 3xl:text-3xl text-black xs:text-nowrap">
                  {v.txt}
                </p>
              </div>
              <div className="relative w-full h-fit rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full min-h-36 md:min-h-44 lg:min-h-64 object-cover"
                  alt={`${v.txt} 서비스 - 비우고 채우고`}
                  src={v.img}
                  loading="lazy"
                  width={475}
                  height={477}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
